import React, { useEffect, useState } from "react";
import type { ReactNode } from "react";
import {
  loadDemoPrivacyBlur,
  subscribeToDemoPrivacyBlur,
} from "./preference";
import "./styles.css";

export const DEMO_PRIVACY_BLUR_CLASS = "demo-privacy-blur";

export interface DemoPrivacyBlurProps {
  enabled: boolean;
  children: ReactNode;
}

export const DemoPrivacyBlur: React.FC<DemoPrivacyBlurProps> = ({
  enabled,
  children,
}) => {
  if (!enabled) return <>{children}</>;
  if (children == null || children === "" || children === false) {
    return <>{children}</>;
  }
  return (
    <span className={DEMO_PRIVACY_BLUR_CLASS} aria-hidden="true">
      {children}
    </span>
  );
};

export function useDemoPrivacyBlur(): boolean {
  const [enabled, setEnabled] = useState(loadDemoPrivacyBlur);
  useEffect(() => subscribeToDemoPrivacyBlur(setEnabled), []);
  return enabled;
}
